// config.js
const config = {
    backendUrl: 'http://localhost:5000', // Update this with your backend URL
  };
  
  export default config;
  